// src/components/ContactFloatingButton.js
import React, { useState } from "react";
import styles from "../styles/CallUsFloatingButton.module.css";
import { FiPhone, FiMessageCircle } from "react-icons/fi"; // Or FiMessageSquare, FiSend, etc.

const ContactFloatingButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = "09385912556";

  const handlePhoneCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleWhatsAppChat = () => {
    window.open(`https://wa.me/${phoneNumber}`, "_blank");
  };

  return (
    <>
      <button
        className={styles.floatingButton}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="تماس با ما"
      >
        <FiPhone />
      </button>

      {isOpen && (
        <div className={styles.modalOverlay} onClick={() => setIsOpen(false)}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className={styles.closeButton}
              onClick={() => setIsOpen(false)}
              aria-label="بستن"
            >
              &times;
            </button>
            <h2>تماس با ما</h2>
            <div className={styles.contactOptions}>
              <button onClick={handlePhoneCall} className={styles.optionButton}>
                <FiPhone /> تماس با کارشناس
              </button>
              <button
                onClick={handleWhatsAppChat}
                className={styles.optionButton}
              >
                <FiMessageCircle /> چت در واتس‌اپ
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ContactFloatingButton;
